import { Link } from "react-router-dom";

/**
 * Bonworld crest — refined, professional, timeless.
 * Circular monogram with a fine gold ring, an inner hairline, a small
 * heritage star, and an upright serif "B". Paired with an all-caps
 * Playfair Display wordmark. Inspired by the visual restraint of
 * institutional trust marks (Bessemer, Pictet, Rothschild) but on a
 * dark ground with warm gold.
 */
export const Logo = ({ size = 44, wordmark = true, small = false, tone = "gold" }) => {
  const stroke = tone === "gold" ? "#D4AF37" : "#F8F9FA";
  return (
    <Link to="/" className="flex items-center gap-4 group" aria-label="Bonworld Family Office">
      <span
        className="relative inline-block shrink-0"
        style={{ width: size, height: size }}
      >
        <svg
          viewBox="0 0 64 64"
          width={size}
          height={size}
          xmlns="http://www.w3.org/2000/svg"
          className="block"
        >
          {/* Outer circle */}
          <circle cx="32" cy="32" r="30" fill="none" stroke={stroke} strokeWidth="1" />
          {/* Inner hairline */}
          <circle cx="32" cy="32" r="26" fill="none" stroke={stroke} strokeWidth="0.5" opacity="0.35" />
          {/* Serifed capital B centered */}
          <text
            x="32"
            y="42"
            textAnchor="middle"
            fill={stroke}
            fontFamily="Playfair Display, ui-serif, Georgia, serif"
            fontSize="30"
            fontWeight="600"
          >
            B
          </text>
          {/* Tiny heritage star at 12 o'clock */}
          <path
            d="M32 5.4 L32.9 8 L35.6 8 L33.4 9.6 L34.3 12.2 L32 10.6 L29.7 12.2 L30.6 9.6 L28.4 8 L31.1 8 Z"
            fill={stroke}
          />
          {/* Bottom hairline arc for structure */}
          <path
            d="M14 56 L50 56"
            stroke={stroke}
            strokeWidth="0.6"
            opacity="0.55"
          />
        </svg>
      </span>
      {wordmark && (
        <div className="leading-[1.05] flex flex-col">
          <div
            className={`font-serif-display text-white ${small ? "text-[15px]" : "text-[18px]"}`}
            style={{ letterSpacing: "0.22em", textTransform: "uppercase", fontWeight: 500 }}
          >
            BONWORLD
          </div>
          <div className="text-[9px] tracking-[0.42em] uppercase text-muted mt-1">
            Family Office · Singapore
          </div>
        </div>
      )}
    </Link>
  );
};

export default Logo;
